function animateNumberReveal(selector) {
  const items = document.querySelectorAll(selector);

  if (items.length === 0) return;

  function getRandomCharacter() {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
    return chars.charAt(Math.floor(Math.random() * chars.length));
  }

  function animateNumbers(item) {
    const targetNumber = item.innerText;

    // Create a document fragment to batch DOM manipulations
    const fragment = document.createDocumentFragment();

    // Split the target number into spans and append to the fragment
    targetNumber.split("").forEach((char) => {
      const span = document.createElement("span");
      span.textContent = char; // Initially set to the target number
      fragment.appendChild(span);
    });

    // Append the fragment to the item
    item.innerHTML = ""; // Clear the original text
    item.appendChild(fragment);
    const numberSpans = item.querySelectorAll("span"); // Get spans after appending
    numberSpans.forEach((span, index) => {
      const randomInterval = setInterval(() => {
        span.textContent = getRandomCharacter();
      }, 50);

      // Stop the randomization after a certain time and set the final number
      setTimeout(
        () => {
          clearInterval(randomInterval);
          span.textContent = targetNumber[index]; // Set to the original character
        },
        700 + index * 200, // Stagger the reveal for each character
      );
    });
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateNumbers(entry.target);
        observer.unobserve(entry.target);
      }
    });
  });

  items.forEach((item) => {
    observer.observe(item);
  });
}

let prevWidth = window.innerWidth;

window.addEventListener("resize", function () {
  let currentWidth = window.innerWidth;

  if (currentWidth !== prevWidth) {
    prevWidth = currentWidth;

    setTimeout(() => {
      // ScrollTrigger.refresh();
    }, 200);
  }
});

window.addEventListener("orientationchange", function () {
  setTimeout(() => {
    // ScrollTrigger.refresh();
  }, 200);
});

const SCOPE_AI_REVEAL_DELAY = 900;

function initScopeAiWidget() {
  const widget = document.getElementById("scopeAi");
  if (!widget) return;

  const card = widget.querySelector(".scope-ai__card");
  const minimizeBtn = widget.querySelector(".scope-ai__minimize");
  const pillBtn = widget.querySelector(".scope-ai__pill");

  function playEnter(el) {
    el.classList.add("is-anim-enter");
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.remove("is-anim-enter");
      });
    });
  }

  minimizeBtn.addEventListener("click", function () {
    card.classList.add("is-anim-leave");
    window.setTimeout(function () {
      widget.classList.add("is-collapsed");
      card.classList.remove("is-anim-leave");
      playEnter(pillBtn);
    }, 200);
  });

  pillBtn.addEventListener("click", function () {
    pillBtn.classList.add("is-anim-leave");
    window.setTimeout(function () {
      widget.classList.remove("is-collapsed");
      pillBtn.classList.remove("is-anim-leave");
      playEnter(card);
    }, 200);
  });
}

function initScopeAiReveal() {
  const widget = document.getElementById("scopeAi");
  if (!widget) return;

  window.setTimeout(function () {
    widget.classList.remove("scope-ai--pending");
    void widget.offsetWidth;
    requestAnimationFrame(function () {
      widget.classList.add("is-visible");
    });
  }, SCOPE_AI_REVEAL_DELAY);
}

function initFloatingWidgetsDock() {
  const fw = document.querySelector(".floating-widgets");
  const main = document.querySelector("main.wrg.main");
  if (!fw || !main) return;

  let ticking = false;

  function updateDockState() {
    ticking = false;
    // Dock (scroll away with the page) the instant floating fixed at the
    // usual offset would start to overlap the footer; float again otherwise.
    const shouldDock = main.getBoundingClientRect().bottom <= window.innerHeight;
    fw.classList.toggle("is-docked", shouldDock);
  }

  function requestUpdate() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateDockState);
    }
  }

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate);
  updateDockState();
}

document.addEventListener("DOMContentLoaded", function () {
  animateNumberReveal(".jsCounter");
  initScopeAiWidget();
  initScopeAiReveal();
  initFloatingWidgetsDock();
});

//# sourceMappingURL=home.js.map
